export class Organisation {
	public constructor(
		public readonly identity: string,
		public readonly name: string
	) {}
}
